const benefits = [
  {
    icon: "ri-time-line",
    title: "30 minute call",
    subtitle: "Focused, efficient, and valuable",
  },
  {
    icon: "ri-video-chat-line",
    title: "Zoom or Phone",
    subtitle: "Whatever works best for you",
  },
  {
    icon: "ri-shield-check-line",
    title: "No pressure, ever",
    subtitle: "Just an honest conversation",
  },
  {
    icon: "ri-gift-line",
    title: "Free resources included",
    subtitle: "Walk away with actionable tips",
  },
];

import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function BookSection() {
  const { ref, visible } = useScrollReveal();

  return (
    <section id="book" className="py-20 bg-[#fafaf7]">
      <div ref={ref} className={`mx-auto px-4 md:px-6 max-w-6xl transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-7'}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="flex flex-col gap-8">
            <div>
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-olive-500 text-olive-500 text-xs font-semibold tracking-widest uppercase">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-sm"></i>
                </span>
                Free Consultation
              </span>
            </div>
            <div>
              <h2 className="font-heading text-4xl md:text-5xl font-bold text-olive-900 leading-tight">
                Schedule Your
                <br />
                <span className="text-olive-500">Free Consultation</span>
              </h2>
              <p className="mt-4 text-olive-600 text-base leading-relaxed max-w-md">
                Pick a time that works best for you. We'll{" "}
                <span className="text-olive-500 font-medium">
                  chat about your goals
                </span>
                , your family's{" "}
                <span className="text-olive-500 font-medium">
                  unique situation
                </span>
                , and map out exactly what path makes the most sense.
              </p>
            </div>
            <div className="flex flex-col gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-olive-100 text-olive-500 flex-shrink-0 mt-0.5">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${b.icon} text-lg`}></i>
                    </span>
                  </div>
                  <div>
                    <p className="text-olive-900 font-semibold text-sm">
                      {b.title}
                    </p>
                    <p className="text-olive-500 text-sm">{b.subtitle}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-4 bg-olive-100 rounded-xl px-5 py-4">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-olive-500 text-xl"></i>
                </span>
              </div>
              <div>
                <p className="text-olive-600 text-xs mb-0.5">
                  Prefer to email?
                </p>
                <a
                  href="mailto:carol@wellnessandfreedom.net"
                  className="text-olive-500 font-semibold text-sm hover:underline cursor-pointer"
                >
                  carol@wellnessandfreedom.net
                </a>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img
                alt="Peaceful consultation space"
                className="w-full h-full object-cover object-top"
                src="https://public.readdy.ai/ai/img_res/f899267c73805704cd13d1edd0fc572b.jpg"
              />
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden border border-olive-200 bg-white">
            <iframe
              src="https://calendly.com/carol-berry305?embed_type=Inline&hide_gdpr_banner=1"
              width="100%"
              height="660"
              title="Schedule a Free Consultation - Carol Berry"
              className="block"
              style={{ border: 0 }}
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}